module.exports = __webpack_public_path__ + "static/matthew-5b4576cca3aa60b407900af3eb1577d9.jpg";